import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/logo';
import { Button } from '@/components/ui/button';
import { useSession } from '@/stores/session';

/** Layout for anonymous, no-login pages (`/s/$token`, `/r`, `/r/$code`): mobile-first, no session, no shop chrome. */
export const Route = createFileRoute('/_public')({
  component: PublicLayout,
});

function PublicLayout() {
  const { t } = useTranslation('people');
  const locale = useSession((s) => s.locale);
  const setLocale = useSession((s) => s.setLocale);
  return (
    <div className="min-h-dvh bg-canvas">
      <header className="mx-auto flex max-w-xl items-center justify-between px-4 py-4">
        <Logo variant="wordmark" />
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => setLocale(locale === 'th' ? 'en' : 'th')}
        >
          {t('public.language')}
        </Button>
      </header>
      <main className="mx-auto max-w-xl px-4 pb-16">
        <Outlet />
      </main>
    </div>
  );
}
